import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets.app/images/logo-sign-up.svg'


const _withScopeId = n => (_pushScopeId("data-v-2e3964e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sign-up pop-up" }
const _hoisted_2 = { class: "sign-up__inner" }
const _hoisted_3 = { class: "sign-up__content" }
const _hoisted_4 = { class: "sign-up__logo-text-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont iback" }, null, -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sign-up__logo-img",
  src: _imports_0,
  alt: "Shortform"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "sign-up__form-box" }
const _hoisted_10 = { class: "shortform-sign-up" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "shortform-sign-up__title" }, "Log In", -1))
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = { class: "shortform-sign-up__group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "shortform-sign-up__label",
  for: "login_email"
}, "Email Address", -1))
const _hoisted_15 = { class: "shortform-sign-up__group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "shortform-sign-up__label",
  for: "login_password"
}, "Password", -1))
const _hoisted_17 = { class: "shortform-sign-up__group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Forgot your password?", -1))
const _hoisted_19 = { class: "shortform-sign-up__group" }
const _hoisted_20 = { class: "shortform-sign-up__submit button button--theme" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "shortform-sign-up__submit button button--theme",
  type: "submit"
}, " Log In ", -1))
const _hoisted_22 = { class: "shortform-sign-up__other-way" }
const _hoisted_23 = { class: "shortform-sign-up__log-in" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sign up now", -1))

import { computed, onBeforeMount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useWait } from '@/app/composables/useWait'

import { LoginView } from '@/models/auth/models'
import { platform } from '@/services/platform'
import { authCssFix } from '@/helpers/html'
import { assertNotNull } from '@/helpers/typing'
import { auth } from '@/services/auth'
import { notificationService } from '@/services/notification'
import { backend } from '@/services/backend'

import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'

import SocialAuth from '@/app/components/auth/SocialAuth.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import { AuthMode } from '@/models/auth/google'


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const wait = useWait()

const passwordInput = ref<InstanceType<typeof InputWithContextMenu> | null>(
  null,
)

const view = ref<LoginView | null>(null)

const authMode = ref<AuthMode>(AuthMode.Signin)

const isNativeIOSApp = ref(false)

async function onStart(): Promise<void> {
  wait.start('Login')

  if (isTemporaryUser()) {
    // Log out the user if they are already logged in.
    // This should only be possible during the
    // app_browse_15807 experiment, where users can
    // go to the login page without logging out first.
    await notificationService.unsubscribe()
    await backend.logout()
  }
}

function onSuccess(nextPage: Record<string, unknown> | null): void {
  wait.start('Login')

  const redirectQuery = router.currentRoute.value.query?.redirect

  if (redirectQuery) {
    router.push(redirectQuery as string)
  } else if (nextPage) {
    router.push(nextPage)
  }
  wait.end('Login')
}

function onError(): void {
  wait.end('Login')
}

onBeforeMount(async () => {
  view.value = new LoginView(onStart, onSuccess, onError)
})

const _view = computed(() => {
  return assertNotNull(view.value)
})

function isTemporaryUser(): boolean {
  return auth.isTemporaryUser()
}

onMounted(async () => {
  // If user name was passed a prop (from the signup with email form)
  if (route.query.email) {
    _view.value.model.email = route.query.email as string
  }

  isNativeIOSApp.value = await platform.isNativeIOSApp()
  if (isNativeIOSApp.value) {
    _iosPasswordInputFix()
  }

  authCssFix()
})

async function submitForm(): Promise<void> {
  await _view.value.start()
}

const signupRoute = computed(() => {
  const routeData = {
    name: 'signup',
    query: route.query,
  }
  // If we have the email set, pass it on to the signup page.
  if (_view.value.model.email) {
    routeData.query.email = _view.value.model.email
  }
  return routeData
})

/**
 * In the iOS app when autofilling the login credentials using Keychain, 1Password
 * etc., the password field gets filled only visually but the value in our model
 * does not get updated.
 *
 * This is related to a bug in WebKit in that the 'input' event
 * does not get fired for the element when filled by a password manager. So we use
 * the below workaround to explicitly listen to the 'change' event and then update
 * the value of our model.
 *
 * For more information see:
 * - https://github.com/ionic-team/ionic-framework/issues/23335#issuecomment-845270643
 * - https://forum.ionicframework.com/t/vuejs-password-autofill-value-empty/217195/4
 */
function _iosPasswordInputFix(): void {
  passwordInput.value?.$el.addEventListener('change', (ev: Event) => {
    requestAnimationFrame(() => {
      _view.value.model.password = (ev.target as HTMLInputElement).value
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (isTemporaryUser())
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "login__back-15807",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
              }, [
                _hoisted_5,
                _createTextVNode(" Back ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            class: "sign-up__logo",
            href: isNativeIOSApp.value ? '#' : '/'
          }, _hoisted_8, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("form", {
            class: "shortform-sign-up__form",
            role: "form",
            novalidate: "",
            onSubmit: _withModifiers(submitForm, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(InputWithContextMenu, {
                id: "login_email",
                modelValue: view.value.model.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((view.value.model.email) = $event)),
                class: _normalizeClass(["shortform-sign-up__input", view.value.validation.stateClass('email')]),
                type: "email",
                placeholder: "",
                autofocus: !isNativeIOSApp.value
              }, null, 8, ["modelValue", "class", "autofocus"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(InputWithContextMenu, {
                id: "login_password",
                ref_key: "passwordInput",
                ref: passwordInput,
                modelValue: view.value.model.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((view.value.model.password) = $event)),
                type: "password",
                autocomplete: "current-password",
                placeholder: "",
                class: _normalizeClass(["shortform-sign-up__input", view.value.validation.stateClass('password')])
              }, null, 8, ["modelValue", "class"]),
              _createVNode(FormError, {
                errors: view.value.validation.errors,
                field: "email",
                style: {"font-size":"90%","display":"block"}
              }, null, 8, ["errors"]),
              _createVNode(FormError, {
                errors: view.value.validation.errors,
                field: "password",
                style: {"font-size":"90%","display":"block"}
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: { name: 'password_forgot', query: _ctx.$route.query },
                class: "shortform-sign-up__forgot-password"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_v_wait, {
                for: "Login",
                style: {"display":"flex"}
              }, {
                waiting: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _createTextVNode(" Logging In "),
                    _createVNode(ButtonSpinner)
                  ])
                ]),
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              })
            ])
          ], 40, _hoisted_12),
          _createVNode(SocialAuth, {
            onStart: onStart,
            onSuccess: onSuccess,
            onError: onError,
            authMode: authMode.value
          }, null, 8, ["authMode"]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("p", _hoisted_23, [
              _createTextVNode(" New to Shortform? "),
              _createVNode(_component_router_link, {
                to: _unref(signupRoute),
                style: {"color":"#ffb600"}
              }, {
                default: _withCtx(() => [
                  _hoisted_24,
                  _createTextVNode(".")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})